import { HeaderWrapper } from "./styled"
import Logo from "assets/images/logo.png"
import { Link } from "react-router-dom"
import Search from "./components/Search"
import User from "./components/User";
import { FaServicestack, FaWifi } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { authAction } from "redux/slice/authSlice"
import { useEffect } from "react";
import { newsCategoriesSelector, tourTypeSelector } from "redux/selector"

const Header = () => {
    const dispatch = useDispatch()
    const tourTypeState = useSelector(tourTypeSelector)
    const newsCategoryState = useSelector(newsCategoriesSelector)
    useEffect(() => {
        const userInfo = JSON.parse(localStorage.getItem("userInfo"))
        if (userInfo)
            dispatch(authAction.getInfo())
    }, [dispatch])

    return (
        <HeaderWrapper>
            <div className="grid wide">
                <div className="header_main">
                    <div className="box_center">
                        <div className="box_logo">
                            <Link to="/" className="logo_main">
                                <img src={Logo} alt="logo" />
                            </Link>
                        </div>
                        <div className="box_search">
                            <Search />
                        </div>
                        <div className="box_profile">
                            {
                                newsCategoryState?.newsCategoriesListAll?.length > 0 &&
                                <div className="ml-15 menu">
                                    <span className="menu_name s-18"><FaWifi style={{ fontSize: "20px" }} /> Tin tức</span>
                                    <ul className="submenu">
                                        {
                                            newsCategoryState.newsCategoriesListAll.map((item, index) => (
                                                <li className="submenu_item" key={index}>
                                                    <Link to={`/news-category/${item.slug}`}>
                                                        {item.name}
                                                    </Link>
                                                </li>
                                            ))
                                        }

                                    </ul>
                                </div>
                            }
                            {
                                tourTypeState?.toutTypeListAll?.length > 0 &&
                                <div className="menu">
                                    <span className="menu_name s-18"><FaServicestack style={{ fontSize: "20px" }} /> Loại tour</span>
                                    <ul className="submenu">
                                        {
                                            tourTypeState.toutTypeListAll.map((item, index) => (
                                                <li className="submenu_item" key={index}>
                                                    <Link to={`/tour-type/${item.slug}`}>
                                                        {item.name}
                                                    </Link>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            }

                            <div className="user">
                                <User />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </HeaderWrapper>
    )
}

export default Header